import { render } from "./discovery.vue?vue&type=template&id=4cff3026&scoped=true"
import script from "./discovery.vue?vue&type=script&lang=js"
export * from "./discovery.vue?vue&type=script&lang=js"

import "./discovery.vue?vue&type=style&index=0&id=4cff3026&lang=less&scoped=true"

import exportComponent from "D:\\myWorkspace\\CoreWeb\\MyNews\\ClientApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cff3026"]])

export default __exports__